import CreateRegistryForm from '@/components/learing-registry/create-registry-form/create-registry-form';
import { learningRegistryAPI } from '@/providers/apis/learning-registry/learning-registry';
import { isAPICatchError } from '@/utils/utils';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'create-tool',
    components: {
        'add-new-tool': CreateRegistryForm,
    },
})

export default class CreateTool extends Vue {


    // -----------------------------------------------------------------------
    // Properties

    @Prop()
    private toolPartners: any;



    // --------------------------------------------------------------------------
    // Actions

    private onGoBack() {
        this.$router.push('/partner-catalog/tool-registry');
    }

    private onAddTool(toolData: any) {
        learningRegistryAPI.saveToolProviderInfo(toolData).then((id: any) => {
            if (!isAPICatchError(id)) {
                toolData.providerId = parseInt(id, 0);
                toolData.registryType = 'tool_registry';
                learningRegistryAPI.saveToolsToProvider(toolData).then((data: any) => {
                    if (!isAPICatchError(data)) {
                        this.$router.push('/partner-catalog/tool-registry');
                    } else {
                        this.validationToastMessage();
                    }
                });
            } else {
                this.validationProviderToastMessage();
            }
        });
    }

    private validationToastMessage() {
        this.$bvToast.toast(
            this.$i18n.t('error.api_faild_or_duplucate_tool_name') as string,
            {
                title: this.$i18n.t('error') as string,
                variant: 'danger',
                solid: true,
            },
        );
    }

    private validationProviderToastMessage() {
        this.$bvToast.toast(
            this.$i18n.t('error.internal_error') as string,
            {
                title: this.$i18n.t('error') as string,
                variant: 'danger',
                solid: true,
            },
        );
    }

}
